import {PIXI} from '@colonist/pixi'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {UIPrivateAdController} from './UIPrivateAdController'
import {UIAdElements} from './UIAdElements'
import {UIAdBlockState} from './UIAdBlockState'
import {UIAdBlockController} from './UIAdBlockController'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {AnalyticEventValue, AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UIAIPAdController} from './UIAIPAdController'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIAdController} from '../../../shared/scripts/ui_ad/UIAdController'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {uiManager} from '../EntryHomepage'
import {Scene} from '../ui_html/UISceneTypes'
import {createDeferredPromise} from '@colonist/utils'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {UserSessionUtils} from '../../../shared/scripts/UserSessionUtils'

export class UIWAdController extends UIAdController {
    readonly adblockState: UIAdBlockState
    readonly adblockController: UIAdBlockController

    private readonly adElements: UIAdElements
    private readonly privateAdController: UIPrivateAdController
    private readonly aipAdController: UIAIPAdController

    constructor() {
        super()
        this.adblockState = new UIAdBlockState()
        this.adblockController = new UIAdBlockController()
        this.adElements = new UIAdElements()
        this.privateAdController = new UIPrivateAdController(this.adElements)
        this.aipAdController = new UIAIPAdController(this.adElements)

        void this.adBlockAction()
        window.addEventListener('resize', () => {
            this.handleBottomInGameAd()
        })
        this.createRemoveAdButtonActions()
        if(this.adblockState.isAdblockActive == false) {
            this.listenIfAdBlockStateChanges()
        }
    }

    private createRemoveAdButtonActions() {
        if(this.adElements.removeAdInGameLeft == undefined) return
        if(this.adElements.removeAdInGameRight == undefined) return
        setElementOnClick(this.adElements.removeAdInGameLeft, () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.InGameRemoveAdButtonLeft,
            }
            void CA.sendAnalyticEvent(eventData)
        })

        setElementOnClick(this.adElements.removeAdInGameRight, () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.InGameRemoveAdButtonRight,
            }
            void CA.sendAnalyticEvent(eventData)
        })
    }

    private async adBlockAction() {
        const adblockIsActive = this.adblockState.isAdblockActive
        if(adblockIsActive) {
            if(!UIUtilsEjsVariables.showVliAdAtBottomInGame) this.aipAdController.stopRefreshing()
            UIWAdController.hideAllVLIAds()
            this.privateAdController.startRefreshing()
            return
        }

        await ClientUserState.waitUntilFresh
        const shouldShowPrivateAds = ClientUserState.userState?.items.hideAds() || UIUtilsEjsVariables.isUserOnDiscord || !UserSessionUtils.shouldShowLobbyAds()

        if(shouldShowPrivateAds) this.privateAdController.startRefreshing()
        this.toggleModeSelectorAdVisibility(shouldShowPrivateAds)

        if(!UIUtilsEjsVariables.showVliAdAtBottomInGame) this.aipAdController.startRefreshing()
    }

    async showLobbyVerticalAds() {
        await ClientUserState.waitUntilFresh
        if(!UserSessionUtils.shouldShowLobbyAds()) return

        if(this.adElements.containerMainPageRightTop != undefined) this.adElements.containerMainPageRightTop.style.display = 'block'
        if(this.adElements.containerMainPageRightMiddle != undefined) this.adElements.containerMainPageRightMiddle.style.display = 'block'
        if(this.adElements.containerMainPageRightBottom != undefined) this.adElements.containerMainPageRightBottom.style.display = 'block'
    }

    removeLobbyAds() {
        if(this.adElements.containerMainPageRightTop != undefined) this.adElements.containerMainPageRightTop.style.display = 'none'
        if(this.adElements.containerMainPageRightMiddle != undefined) this.adElements.containerMainPageRightMiddle.style.display = 'none'
        if(this.adElements.containerMainPageRightBottom != undefined) this.adElements.containerMainPageRightBottom.style.display = 'none'
    }

    showInGameAds() {
        if(PIXI.utils.isMobile.phone) return
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
        this.showRightInGameAd()
        this.showLeftInGameAd()
        this.handleBottomInGameAd()
    }

    hideInGameAds() {
        this.hideRightInGameAd()
        this.hideLeftInGameAd()
        this.handleBottomInGameAd()
    }

    private toggleModeSelectorAdVisibility(shouldHide: boolean) {
        if(this.adElements.modeSelectorAd == undefined) return
        this.adElements.modeSelectorAd.classList.toggle('hidden', shouldHide)
    }

    private showRightInGameAd() {
        if(this.adElements.containerGameRight == undefined) return
        this.adElements.containerGameRight.style.display = 'block'
    }

    private showLeftInGameAd() {
        if(this.adElements.containerGameLeft == undefined) return
        this.adElements.containerGameLeft.style.display = 'block'
    }

    private hideRightInGameAd() {
        if(this.adElements.containerGameRight == undefined) return
        this.adElements.containerGameRight.style.display = 'none'
    }

    private hideLeftInGameAd() {
        if(this.adElements.containerGameLeft == undefined) return
        this.adElements.containerGameLeft.style.display = 'none'
    }

    private static hideAllVLIAds() {
        document.querySelectorAll('.adsbyvli').forEach((e) => (e as HTMLDivElement).style.display = 'none')
    }

    private handleBottomInGameAd() {
        if(this.adElements.containerGameBottomSmall == undefined && this.adElements.containerGameBottom == undefined) return
        if(uiManager.sceneController.scene != Scene.Game) return
        const show = uiGameManager.canvasController.responsiveController.canShowBottomAd()
        const bottomAdElement = UIUtilsEjsVariables.showVliAdAtBottomInGame ? this.adElements.containerGameBottom : this.adElements.containerGameBottomSmall
        bottomAdElement.style.display = show ? 'block' : 'none'
    }

    static async initiatePopupActionFromUserState(isAdblockActive: boolean): Promise<void> {
        if(UIAdBlockController.shouldShowSoftBlockPopup(ClientUserState.userState, isAdblockActive) == true) {
            const promise = createDeferredPromise()
            UIAdBlockController.showDisableAdblockPopup(() => {
                promise.resolve()
            }, true, true)
            return promise
        }
    }

    private listenIfAdBlockStateChanges() {
        if(this.adblockState.isAdblockActive == true) return

        const maxIntervals = 10
        const msPerInterval = 1000
        let intervalCount = 0

        const adblockStateChangeInterval = setInterval(() => {
            if(intervalCount >= maxIntervals) {
                clearInterval(adblockStateChangeInterval)
                return
            }
            if(this.adblockState.isAdblockActive == true) {
                clearInterval(adblockStateChangeInterval)
                void this.adBlockAction()
                return
            }

            intervalCount += 1
        }, msPerInterval)
    }
}
